import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
function ContentProfileComponent(props) {
  const { providersContents, currentSection } = props;
  let contentInOrder = [];
  
  contentInOrder.push(
    providersContents
      .sort((a, b) => a.sectionOrder - b.sectionOrder)
      .map(item => {
        if (item.section === currentSection) {
          if (item.category === 'image') {
            return (
              <Grid justifyContent="center">
                <img
                  src={item.linkTo}
                  width="800"
                  height="400"
                  alt={"Image"}
                />
              </Grid>
            );
          } else if (item.category === 'link') {
            return (
              <Grid justifyContent="center">
                <a href={item.linkTo}>{item.linkTo}</a>
              </Grid>
            );
          } else {
            return (<Grid justifyContent="center">
              {item.content.split('\n').map(paragraph => (
                <div>
                  {paragraph}
                </div>
              ))}
            </Grid>)
          }
        }
      })
  );
  contentInOrder.push(
    providersContents
      .sort((a, b) => a.sectionOrder - b.sectionOrder)
      .map(item => {
        if (item.section === currentSection) {
          if (item.category === 'video') {
            return (
              <Grid justifyContent="center">
                <iframe
                  src={item.linkTo}
                  width="800"
                  height="400"
                  frameBorder="0"
                  allowFullScreen="allowFullScreen"
                />
              </Grid>
            );
          }
        }
      })
  );
  return contentInOrder;
}

ContentProfileComponent.PropTypes = {
  providersContents: PropTypes.func,
  currentSection: PropTypes.func,
};

export default ContentProfileComponent;
